import React from 'react';
import { SplitView } from './editorComponents/SplitView';
import { Content, PreviewContent, PreviewMdxContent } from './Content';

import { Image } from './Image';
// import { NewsRoll } from './NewsRoll';
// import { Quote } from './Quote';

export const Sections = ({ isPreviewMode, content }) => {
  const PageContent = isPreviewMode ? PreviewContent : Content;
  const MdxContent = isPreviewMode ? PreviewMdxContent : Content;

  return (
    <>
      {content.map((item, index) => {
        const key = `section-${index}`;
        if (item.type === 'split-view' && item?.primary && item?.secondary) {
          return (
            <div className="container" key={key}>
              <SplitView size="equal-size" isPreviewMode={isPreviewMode}>
                <PageContent>{item.primary}</PageContent>
                <PageContent>{item.secondary}</PageContent>
              </SplitView>
            </div>
          );
        } if (item.type === 'full-width-image' && item?.image) {
          return (
            <div style={{ margin: '6rem 0', height: '60vh', overflow: 'hidden' }} key={key}>
              <Image
                src={item.image}
                alt=""
                size="full"
                style={{
                  height: 'inherit',
                }}
                breakpoints={[
                  { width: 300 },
                  { width: 400 },
                  { width: 500 },
                  { width: 600 },
                  { width: 768 },
                  { width: 940 },
                  { width: 1024 },
                  { width: 1200 },
                  { width: 1400 },
                  { width: 1800 },
                ]}
                sizes="100vw"
              />
            </div>
          );
        } if (item.type === 'markdown' && item?.primary) {
          return (
            <div className="container" key={key}>
              <MdxContent>
                {item.primary}
              </MdxContent>
            </div>
          );
        }
        return <div />;
      })}
    </>
  );
};
